/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DemandeQuotaSupplementaireDto } from '../models/demande-quota-supplementaire-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des demandes de quotas supplémentaires pour les personnes physiques
 */
@Injectable({
  providedIn: 'root',
})
export class DemandesQuotasSupplementairesPersonnePhysiqueService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiqueGetList
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiqueGetListPath = '/api/demandes-quotas-supplementaires-personne-physique/list';

  /**
   * Renvoie la liste des demandes de quotas supplémentaires.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DemandeQuotaSupplementaireDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DemandeQuotaSupplementaireDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de quotas supplémentaires.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueGetList(params?: {
  }): Observable<Array<DemandeQuotaSupplementaireDto>> {

    return this.demandesQuotasSupplementairesPersonnePhysiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DemandeQuotaSupplementaireDto>>) => r.body as Array<DemandeQuotaSupplementaireDto>)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiqueLoadList
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiqueLoadListPath = '/api/demandes-quotas-supplementaires-personne-physique/load-list';

  /**
   * Renvoie la liste des demandes de quotas supplémentaires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de quotas supplémentaires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.demandesQuotasSupplementairesPersonnePhysiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiqueLoadList2
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiqueLoadList2Path = '/api/demandes-quotas-supplementaires-personne-physique/personne/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des demandes de quotas supplémentaires de la personne physique spécifiée pour l'année en cours (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiqueLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiqueLoadList2$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiqueLoadList2Path, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de quotas supplémentaires de la personne physique spécifiée pour l'année en cours (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiqueLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiqueLoadList2(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.demandesQuotasSupplementairesPersonnePhysiqueLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiqueGet
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiqueGetPath = '/api/demandes-quotas-supplementaires-personne-physique/personne/{personnePhysiqueId}/{id}';

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueGet$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiqueGetPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueGet(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonnePhysiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiquePutForPersonne
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiquePutForPersonnePath = '/api/demandes-quotas-supplementaires-personne-physique/personne/{personnePhysiqueId}/{id}';

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiquePutForPersonne()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiquePutForPersonne$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiquePutForPersonnePath, 'put');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiquePutForPersonne$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiquePutForPersonne(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonnePhysiquePutForPersonne$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiqueGet2
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiqueGet2Path = '/api/demandes-quotas-supplementaires-personne-physique/{id}';

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiqueGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueGet2$Response(params: {

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiqueGet2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiqueGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueGet2(params: {

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonnePhysiqueGet2$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiquePut
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiquePutPath = '/api/demandes-quotas-supplementaires-personne-physique/{id}';

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiquePut$Response(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiquePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiquePut(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonnePhysiquePut$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiqueDelete
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiqueDeletePath = '/api/demandes-quotas-supplementaires-personne-physique/{id}';

  /**
   * Supprime la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueDelete$Response(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiqueDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonnePhysiqueDelete(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.demandesQuotasSupplementairesPersonnePhysiqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonnePhysiquePost
   */
  static readonly DemandesQuotasSupplementairesPersonnePhysiquePostPath = '/api/demandes-quotas-supplementaires-personne-physique';

  /**
   * Crée la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonnePhysiquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiquePost$Response(params: {

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonnePhysiqueService.DemandesQuotasSupplementairesPersonnePhysiquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Crée la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonnePhysiquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonnePhysiquePost(params: {

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonnePhysiquePost$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

}
